import { V2StaticLegislationBriefing } from '../../components/static-legislation-briefing/V2StaticLegislationBriefing'
import { V2ProductRegulationPageShell } from './V2ProductRegulationPageShell'

type V2ProductPedRegulationPageProps = {
  productId: string
}

export function V2ProductPedRegulationPage({
  productId,
}: V2ProductPedRegulationPageProps) {
  return (
    <V2ProductRegulationPageShell productId={productId} law="ped">
      {(applies) => <V2StaticLegislationBriefing law="ped" applies={applies} />}
    </V2ProductRegulationPageShell>
  )
}
